// extracted by mini-css-extract-plugin
export var falconContainer = "_vn-2";
export var offerCenter = "_vn-0";
export var roktContainer = "_vn-1";